export default "__VITE_ASSET__CEcs$xyv__"